import { useEffect, useState } from "react";
import React from "react";
import PieChart from "../PieChart/PieChart";
import { useNavigate } from "react-router-dom";
import OperatorShowroomItems from "../OperatorShowroomItems/operatorShowroomItems";
import "./operatorCard.css";

const OperatorCard = ({ operator, colorCounts }) => {
	const navigate = useNavigate();
	const [green, setGreen] = useState(0);
	const [blue, setBlue] = useState(0);
	const [yellow, setYellow] = useState(0);
	const [purple, setPurple] = useState(0);
	const [navy, setNavy] = useState(0);
	const [allProducts, setAllProducts] = useState(false);

	useEffect(() => {
		colorCounts.forEach((count) => {
			switch (count.color) {
				case "green":
					setGreen(count.count);
					break;
				case "blue":
					setBlue(count.count);
					break;
				case "yellow":
					setYellow(count.count);
					break;
				case "purple":
					setPurple(count.count);
					break;
				case "navy":
					setNavy(count.count);
					break;
				default:
					// Handle other colors if needed
					break;
			}
		});
	}, [colorCounts]);

	let count = 0;
	useEffect(() => {
		if (count == 0) {
			console.log(operator);
			console.log(colorCounts);
			count++;
		}
	}, []);

	return (
		<div className="showroom-card fade-in" onClick={() => navigate(`/profile/${operator.licenseNo}`)}>
			<div className="operator-name">{operator.company}</div>
			<div className="operator-info">
				<div className="state-and-type">
					<div className="state-and-type-inner">
						<span>{operator.industry}</span>
						<span>{operator.profile}</span>
					</div>
				</div>
				<div className="state-and-type">
					<div className="state-and-type-inner">
						<span>{operator.state}</span>
						<span>{operator.licenseNo}</span>
					</div>
				</div>
				<div className="pie-chart-operators">
					<PieChart data={[yellow, green, blue, navy, purple, 0, 0]} radius="50%" />
				</div>
				<div
					className="state-and-type see-all-products"
					onClick={(e) => {
						e.stopPropagation();
						e.preventDefault();
						setAllProducts(true);
					}}>
					<span>See All Products</span>
					{allProducts && <OperatorShowroomItems operator={operator} setAllProducts={setAllProducts} />}
				</div>
			</div>
		</div>
	);
};

export default OperatorCard;
